import * as next from '../../../types/next'
import { isBlockUiSchema, isGroupUiSchema } from '../../../utils'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.GroupBlock> = (uischema) => {
  if (!isGroupUiSchema(uischema)) {
    throw new Error('Expected a valid Group Layout control')
  }

  const children = uischema.elements.reduce<next.BlockId[]>((acc, uischema) => {
    if (isBlockUiSchema(uischema)) {
      if (typeof uischema.id !== 'string') {
        throw new Error(
          `Expected a valid block id for scope: ${uischema.scope}`
        )
      }

      acc.push(uischema.id)
    }

    return acc
  }, [])

  return {
    type: next.BLOCK_TYPE.GROUP,
    required: false, // can never be required
    settings: upCommonSettings(uischema),
    children
  }
}
